module.exports = __webpack_public_path__ + "media/app/assets/imgs/Sphir_logo_trademark_WEB-HEADER-309cf7d87fc7d6df7588cacb3b232f53.svg";